export default {
  nav: {
    technology: "ODF Teknolojisi",
    solutions: "Çözümler",
    partnerships: "İş Ortaklıkları",
    about: "Hakkımızda",
    contact: "Bize Ulaşın",
    home: "Ana Sayfa",
  },
  hero: {
    eyebrow: "YENİ NESİL ODF ÇÖZÜMLERİ",
    headline1: "İnovasyon,",
    headline2: "her filmde hayat bulur.",
    copy: "NORTIS, gelişmiş ağızda çözünen film (ODF) ürünlerini modern wellness markaları ve uluslararası pazarlarla buluşturur; pratik bir formatı güvenilir ticari uzmanlıkla bir araya getirir.",
    cta1: "ODF Teknolojisini Keşfedin",
    cta2: "NORTIS ile İş Ortağı Olun",
    trust: "Modern yaşam tarzları için tasarlandı. Küresel fırsatlar için geliştirildi.",
    scroll: "Kaydırın",
  },
  brandline: "Üstün Sunum. Zahmetsiz Deneyim.",
  credibility: {
    title: "Değişen bir dünya için daha akıllı bir format.",
    copy: "Ağızda çözünen filmler, özenle formüle edilmiş içerikleri tablet, kapsül veya sıvıların alışılmış kullanım deneyimine gerek kalmadan sunan rafine ve pratik bir alternatiftir.",
  },
  whatIsOdf: {
    eyebrow: "FORMAT",
    title: "ODF nedir?",
    copy: "ODF, ağızda kolayca çözünmek üzere tasarlanmış ultra ince bir oral filmdir. Kompakt yapısıyla; taşınabilir ve kullanıcı dostu wellness deneyimleri geliştiren markalara modern bir alternatif sunar.",
    benefits: [
      { title: "İnce ve taşınabilir", desc: "Cepte, cüzdanda veya çantada zahmetsizce taşınabilen ultra ince bir format." },
      { title: "Su gerektirmeyen kullanım", desc: "Su veya herhangi bir hazırlık gerektirmeden, her yerde ve her an kullanılabilir." },
      { title: "Hassas tekli sunum", desc: "Her film, tutarlılık gözetilerek tek tek paketlenmiş bağımsız bir birimdir." },
      { title: "İnovasyon için tasarlandı", desc: "Modern ürün konseptleri ve fark yaratan marka deneyimleri için esnek bir zemin." },
    ],
  },
  whyNortis: {
    eyebrow: "NEDEN NORTIS",
    title: "Bir ürün formatının ötesinde: eksiksiz bir pazar fırsatı.",
    copy: "NORTIS, ODF inovasyonu ile ticari pazarlar arasında köprü kurar; potansiyel taşıyan ürünleri, onları ölçeklendirebilecek iş ortaklarıyla buluşturur.",
    points: [
      { title: "ODF odaklı ticari uzmanlık", desc: "Ağızda çözünen film kategorisine ve bu kategorinin ticari dinamiklerine adanmış bir odak." },
      { title: "Uluslararası tedarik ve pazar geliştirme", desc: "Farklı bölgelerde fırsatların belirlenmesi ve pazara giden yolların inşa edilmesi." },
      { title: "Ürün ve marka konumlandırma desteği", desc: "İş ortaklarının ODF konseptlerini hedef kitlelerine ve satış kanallarına göre şekillendirmesine destek." },
      { title: "Esnek B2B iş ortaklığı modelleri", desc: "Distribütörlük, private label ve pazar geliştirme — hedeflerinize göre yapılandırılır." },
      { title: "Kalite odaklı ürün seçimi", desc: "Uygunluk, dokümantasyon ve pazara hazırlık düzeyinin disiplinli biçimde değerlendirilmesi." },
      { title: "Uzun vadeli iş ilişkileri", desc: "Kalıcı ve sürdürülebilir ticari büyüme hedefiyle kurulan iş ortaklıkları." },
    ],
  },
  solutions: {
    eyebrow: "ÇÖZÜM PORTFÖYÜ",
    title: "Modern yaşamın ihtiyaçlarına göre tasarlanmış bir portföy.",
    copy: "NORTIS'in iş ortakları ve dünya genelindeki pazarlarla birlikte geliştirdiği çözüm kategorilerini keşfedin.",
    viewAll: "Tüm çözümleri görüntüleyin",
    requestInfo: "Ürün Bilgisi Talep Edin",
    possibilitiesLabel: "Geliştirme olanakları",
    positioningLabel: "Ticari konumlandırma",
    availabilityLabel: "Pazar mevcudiyeti",
    targetLabel: "Hedef pazar",
    docLabel: "Dokümantasyon durumu",
    sheetLabel: "Bilgi dokümanı",
    sheetOnRequest: "Talep üzerine paylaşılır",
    demoBadge: "Örnek konsept",
    filterAll: "Tümü",
    pageTitle: "Çözümler",
    pageSub: "ODF çözüm kategorilerinden oluşan, filtrelenebilir bir portföy — gerçek ürünler, iş ortaklıkları geliştikçe kolayca eklenebilecek şekilde yapılandırılmıştır.",
    demoNote: "Aşağıdaki içerikler, kategorilerin yönünü göstermek amacıyla hazırlanmış örnek konseptlerdir. Gerçek ticari ürünler, aktif iş ortaklıkları kapsamında tanıtılır.",
  },
  comparison: {
    eyebrow: "FORMAT DENEYİMİ",
    title: "Film formatı diğer formatlarla nasıl karşılaştırılır?",
    copy: "Günlük kullanımdaki formatların pratik özelliklerine tarafsız bir bakış.",
    note: "Bu tablo yalnızca pratik format özelliklerinin tarafsız bir karşılaştırmasıdır; klinik performans veya etkinlik iddiası içermez.",
    formats: ["ODF Film", "Tablet", "Kapsül", "Sıvı"],
    rows: [
      { label: "Taşınabilirlik", values: [2, 2, 2, 0] },
      { label: "Su gerektirmeyen kullanım", values: [2, 0, 0, 1] },
      { label: "Önceden porsiyonlanmış tekli format", values: [2, 2, 2, 0] },
      { label: "Saklama kolaylığı", values: [2, 2, 1, 0] },
      { label: "Dikkat çekmeyen, hareket halinde kullanım", values: [2, 1, 1, 0] },
    ],
  },
  models: {
    eyebrow: "İŞ ORTAKLIĞI MODELLERİ",
    title: "NORTIS ile birlikte büyümenin üç yolu.",
    cta: "İş Ortaklığını Görüşelim",
    items: [
      { title: "Distribütörlük", desc: "Seçili ODF ürünlerini yeni bölgelere ve ticari ağlara taşıyın." },
      { title: "Private Label", desc: "Kendi markanız altında fark yaratan ODF konseptleri geliştirin." },
      { title: "Pazar Geliştirme", desc: "NORTIS ile birlikte ürün konumlandırması, lansman stratejisi ve uzun vadeli pazar varlığı oluşturun." },
    ],
  },
  timeline: {
    eyebrow: "İŞ BİRLİĞİ SÜRECİ",
    title: "İlk görüşmeden pazar büyümesine.",
    steps: [
      { title: "Fırsatın Keşfi", desc: "Hedeflerinizi, pazarlarınızı ve bunlara uygun ODF konseptlerini birlikte değerlendiririz." },
      { title: "Ürün ve Pazar Uyumu", desc: "Doğru ürünleri doğru ticari bağlamla eşleştiririz." },
      { title: "Ticari Değerlendirme", desc: "Koşulları, hacimleri ve gerçekçi bir ticari çerçeveyi birlikte yapılandırırız." },
      { title: "Uyum ve Lansman Hazırlığı", desc: "Lansman öncesinde dokümantasyonu ve pazar gerekliliklerini gözden geçiririz." },
      { title: "Dağıtım ve Büyüme", desc: "Ürünün pazara sunulmasını, yaygınlaşmasını ve iş ortaklığının uzun vadeli büyümesini destekleriz." },
    ],
  },
  quality: {
    eyebrow: "KALİTE VE SORUMLULUK",
    title: "Kalite, doğru soruları sormakla başlar.",
    copy: "NORTIS, her potansiyel iş ortaklığı kapsamında ürün uygunluğunu, dokümantasyonu, ticari hazırlık düzeyini ve pazar gerekliliklerini titizlikle değerlendirir. Ürünlerin bulunabilirliği ve yasal statüsü ülkeden ülkeye farklılık gösterebilir.",
    placeholder: "Doğrulanmış kalite dokümanları ve sertifikalar, iş ortaklıkları ilerledikçe bu alanda yayımlanacaktır.",
  },
  global: {
    eyebrow: "KÜRESEL VİZYON",
    title: "Uluslararası iş birliği için kurulduk",
    copy: "Gelişen küresel pazarlarda değerli ODF fırsatlarını belirlemek için markalar, tedarikçiler, distribütörler ve ticari iş ortaklarıyla birlikte çalışıyoruz.",
  },
  finalCta: {
    title: "Oral wellness'ın yeni neslini birlikte şekillendirelim.",
    copy: "Distribütörlük, private label veya yeni bir ODF ürün konsepti — hangisini araştırıyor olursanız olun, NORTIS görüşmeye hazır.",
    cta: "Görüşme Başlatın",
  },
  footer: {
    desc: "NORTIS, yenilikçi ODF ürünlerini dünya genelindeki markalar, iş ortakları ve pazarlarla buluşturur.",
    nav: "Site Haritası",
    legal: "Yasal",
    privacy: "Gizlilik Politikası",
    terms: "Kullanım Koşulları",
    language: "Dil",
    disclaimer: "Ürünlerin bulunabilirliği, formülasyonu, sınıflandırması ve yasal statüsü ülkeye göre değişiklik gösterebilir. Bu web sitesindeki bilgiler ticari ve genel bilgilendirme amaçlıdır; tıbbi tavsiye niteliği taşımaz.",
    rights: "Tüm hakları saklıdır.",
  },
  tech: {
    eyebrow: "ODF TEKNOLOJİSİ",
    title: "İnceliğin bilimi.",
    sub: "Ağızda çözünen filme dair bilgilendirici bir genel bakış: format, kullanım deneyimi ve açtığı ticari olanaklar.",
    what: {
      title: "Ağızda çözünen film nedir?",
      copy: "Ağızda çözünen film (ODF), ağızda kolayca çözünmek üzere tasarlanmış ultra ince bir tabakadır. Kullanıcı, tablet yutmak ya da sıvı ölçmek yerine tek bir filmi ağzına yerleştirir ve filmin çözünmesini bekler; son derece kompakt bir formatta sessiz ve modern bir deneyim.",
    },
    structure: {
      title: "Genel film yapısı",
      copy: "Kavramsal olarak bir ODF üç bileşeni bir araya getirir: yapısal film tabanı, formüle edilmiş içerikleri taşıyan taşıyıcı matris ve tat ile dokuyu şekillendiren duyusal katman. Kavramsal katmanları ayırmak için diyagramın üzerine gelin veya dokunun.",
      note: "Yalnızca gösterim amaçlı kavramsal bir temsildir.",
      layers: [
        { title: "Duyusal katman", desc: "Tadı, dokuyu ve çözünme deneyimini şekillendirir." },
        { title: "Taşıyıcı matris", desc: "Özenle formüle edilmiş içerikleri filmin içinde taşır." },
        { title: "Yapısal taban", desc: "Filme bütünlüğünü, inceliğini ve dayanıklılığını kazandırır." },
      ],
    },
    experience: {
      title: "Kullanıcı deneyimi",
      copy: "Su yok. Ölçüm yok. Kesinti yok. Film dikkat çekmeden çözünür; seyahatte, iş yerinde veya hareket halindeyken kullanımı son derece doğaldır. Modern tüketiciler için formatın kendisi, marka deneyiminin bir parçası haline gelir.",
    },
    portability: {
      title: "Taşınabilirlik ve ambalaj potansiyeli",
      copy: "Tekli filmler ince saşelerde, zarif çoklu paketlerde veya kompakt dispenserlerde sunulabilir. Bu formatlar, modern perakende raflarına olduğu kadar doğrudan tüketiciye ulaşan kutu açılış deneyimlerine de uyum sağlar.",
    },
    development: {
      title: "Ürün geliştirme olanakları",
      copy: "Film formatı, günlük wellness rutinlerinden hedefli yaşam tarzı konumlandırmalarına kadar geniş bir ürün konsepti yelpazesini destekler ve markalara yoğun rekabetin yaşandığı kategorilerde farklılaşma alanı açar.",
    },
    commercial: {
      title: "Ticari uygulama alanları",
      copy: "ODF konseptleri; wellness, içten güzellik, enerji, uyku ve fonksiyonel içerik kategorilerinde geliştirilmektedir. Bunlar, pratikliğin ve premium deneyimin satın alma kararlarını belirlediği kanallardır.",
    },
    regulatory: {
      title: "Pazar ve mevzuata ilişkin hususlar",
      copy: "Film ürünlerinin sınıflandırması ve tabi olduğu gereklilikler ülkeye ve formülasyona göre değişir. NORTIS her pazarı ayrı ayrı ele alır; ticarileştirme öncesinde dokümantasyonu ve mevzuat çerçevesini iş ortaklarıyla birlikte inceler.",
    },
    cta: "Teknik Bilgi Talep Edin",
  },
  partnership: {
    eyebrow: "PRIVATE LABEL VE DİSTRİBÜTÖRLÜK",
    title: "İki farklı yol. Tek bir iş ortaklığı standardı.",
    sub: "NORTIS, ticari iş birliklerini iki temel model üzerine yapılandırır. Her iki model de netlik, hız ve uzun vadeli büyüme hedefiyle tasarlanmıştır.",
    plTitle: "Private Label",
    plDesc: "Konseptten rafa uzanan tüm süreci NORTIS koordine ederken, kendi markanız altında fark yaratan ODF konseptleri geliştirin.",
    plSteps: ["Konsept değerlendirmesi", "Ürün seçimi", "Marka ve ambalaj koordinasyonu", "Dokümantasyon incelemesi", "Pazar lansmanı hazırlığı", "Ticari ölçeklendirme"],
    distTitle: "Distribütörlük",
    distDesc: "Seçili ODF ürünlerini, her aşamada yapılandırılmış destek eşliğinde kendi bölgenize ve ticari ağınıza taşıyın.",
    distSteps: ["Bölge değerlendirmesi", "Portföy uyumu", "Ticari koşullar", "Pazara giriş planlaması", "Lansman desteği", "Uzun vadeli büyüme"],
    formTitle: "İş ortaklığı başvurusu yapın",
    formSub: "Hedeflerinizi bizimle paylaşın; ekibimiz sonraki adımlar için sizinle iletişime geçsin.",
  },
  about: {
    eyebrow: "NORTIS HAKKINDA",
    title: "Yarını şekillendiren formata odaklanıyoruz.",
    copy: "NORTIS; potansiyel taşıyan ODF inovasyonlarını, bunları değerli ticari ürünlere dönüştürebilecek markalar, iş ortakları ve pazarlarla buluşturmak amacıyla kuruldu. Girişimci hızı, uluslararası bakış açısını ve uzun vadeli iş ortaklıklarına yönelik disiplinli bir yaklaşımı bir araya getiriyoruz.",
    positioning: "NORTIS, yenilikçi ODF ürünlerini dünya genelindeki markalar, iş ortakları ve pazarlarla buluşturur.",
    principlesTitle: "İlkelerimiz",
    principles: [
      { title: "Hassasiyet", desc: "Ürün değerlendirmesinden iş ortağı iletişimine kadar her ayrıntıda özen." },
      { title: "Güven", desc: "Şeffaf beklentiler ve arkasında durduğumuz taahhütler." },
      { title: "İlerleme", desc: "Sürekli gelişime ve modern formatlara duyulan inanç." },
      { title: "İş Ortaklığı", desc: "Çeyrek dönemler için değil, yıllar boyunca değer üretmek üzere tasarlanan ilişkiler." },
      { title: "Küresel Bakış Açısı", desc: "Sınırların, pazarların ve tüketici kültürlerinin ötesinde düşünmek." },
    ],
  },
  contact: {
    eyebrow: "İLETİŞİM",
    title: "Görüşmeye başlayalım.",
    sub: "İlgilendiğiniz konuyla ilgili birkaç ayrıntı paylaşın; ekibimiz en kısa sürede size dönüş yapsın.",
    name: "Ad soyad",
    company: "Şirket",
    email: "Kurumsal e-posta",
    country: "Ülke",
    website: "Web sitesi",
    interest: "İlgilendiğiniz iş ortaklığı modeli",
    market: "Hedeflenen pazar veya bölge",
    message: "Mesajınız",
    consent: "Bu başvuruya yanıt verilebilmesi amacıyla NORTIS'in bilgilerimi saklamasına onay veriyorum.",
    submit: "Mesajı Gönder",
    sending: "Gönderiliyor…",
    successTitle: "Teşekkürler — mesajınız bize ulaştı.",
    successCopy: "Ekibimiz başvurunuzu inceleyecek ve en kısa sürede size geri dönecektir.",
    successAnother: "Yeni bir mesaj gönderin",
    errorRequired: "Bu alanın doldurulması zorunludur.",
    errorEmail: "Lütfen geçerli bir kurumsal e-posta adresi girin.",
    errorConsent: "Formu gönderebilmek için onay vermeniz gerekmektedir.",
    errorSubmit: "Bir sorun oluştu. Lütfen tekrar deneyin.",
    optional: "İsteğe bağlı",
    interests: {
      distribution: "Distribütörlük",
      privateLabel: "Private label",
      sourcing: "Ürün tedariki",
      marketDev: "Pazar geliştirme",
      general: "Genel iş ortaklığı",
      product: "Ürün bilgisi",
      technical: "Teknik bilgi",
    },
    selectPlaceholder: "Bir seçenek belirleyin",
  },
  legal: {
    privacyTitle: "Gizlilik Politikası",
    termsTitle: "Kullanım Koşulları",
    updated: "Son güncelleme",
    privacy: [
      { h: "1. Genel bakış", p: "Bu Gizlilik Politikası, NORTIS'in bu web sitesi aracılığıyla iletilen bilgileri nasıl topladığını, kullandığını ve koruduğunu açıklar. Kurumsal iletişim bilgilerini sorumlu ve şeffaf bir biçimde işlemeyi taahhüt ediyoruz." },
      { h: "2. Topladığımız bilgiler", p: "İletişim veya iş ortaklığı formu gönderdiğinizde; ad soyad, şirket, kurumsal e-posta, ülke, web sitesi, ilgi alanı ve mesaj içeriği gibi tarafınızca sağlanan bilgileri toplarız." },
      { h: "3. Bilgilerin kullanım amacı", p: "İletilen bilgiler yalnızca başvurunuzu yanıtlamak, olası ticari iş birliğini değerlendirmek ve ilgili iş ortaklığı konularında sizinle iletişim kurmak amacıyla kullanılır. Kişisel verilerinizi satmayız." },
      { h: "4. Verilerin saklanması ve güvenliği", p: "Form gönderileri, uygulama veritabanımızda güvenli bir şekilde saklanır. Erişim, başvuruları yanıtlamakla görevli personelle sınırlıdır. Saklanan verilerin korunması için makul teknik önlemler alırız." },
      { h: "5. Verilerin saklanma süresi", p: "Başvuru verilerini, iş ilişkisinin yönetimi için gerekli olduğu sürece veya yürürlükteki mevzuatın öngördüğü ölçüde saklarız. Verilerinizin silinmesini bizimle iletişime geçerek talep edebilirsiniz." },
      { h: "6. Haklarınız", p: "Bulunduğunuz ülkenin mevzuatına bağlı olarak, hakkınızda sakladığımız kişisel verilere erişme, bunların düzeltilmesini veya silinmesini talep etme hakkına sahip olabilirsiniz. Bu haklarınızı kullanmak için web sitesi üzerinden bizimle iletişime geçebilirsiniz." },
      { h: "7. Politika değişiklikleri", p: "Bu Gizlilik Politikası zaman zaman güncellenebilir. Önemli değişiklikler, güncellenmiş revizyon tarihiyle birlikte bu sayfada duyurulur." },
    ],
    terms: [
      { h: "1. Koşulların kabulü", p: "Bu web sitesine erişerek ve siteyi kullanarak bu Kullanım Koşullarını kabul etmiş sayılırsınız. Koşulları kabul etmiyorsanız lütfen siteyi kullanmayı bırakın." },
      { h: "2. Bilgilendirme amacı", p: "Bu web sitesindeki içerik yalnızca ticari ve genel bilgilendirme amaçlıdır. Tıbbi, hukuki veya mevzuata ilişkin tavsiye niteliği taşımaz; hiçbir içerik ürün iddiası olarak yorumlanmamalıdır." },
      { h: "3. Ürün bulunabilirliği", p: "Ürünlerin bulunabilirliği, formülasyonu, sınıflandırması ve yasal statüsü ülkeye göre değişebilir. Bu web sitesindeki hiçbir içerik, belirli bir ülkede herhangi bir ürünün satışına ilişkin bir teklif oluşturmaz." },
      { h: "4. Fikri mülkiyet", p: "NORTIS adı, görsel kimliği ve web sitesi içeriği NORTIS'e aittir. Önceden yazılı izin alınmaksızın site içeriği çoğaltılamaz veya dağıtılamaz." },
      { h: "5. Sorumluluğun sınırlandırılması", p: "NORTIS, web sitesindeki bilgilerin doğruluğunu korumak için makul özeni gösterir; ancak bilgilerin eksiksiz olduğunu garanti etmez. Yürürlükteki mevzuatın izin verdiği ölçüde, NORTIS web sitesi içeriğine dayanılarak alınan kararlardan sorumlu tutulamaz." },
      { h: "6. Üçüncü taraf bağlantıları", p: "Bu web sitesi, üçüncü taraf kaynaklara bağlantılar içerebilir. NORTIS, harici sitelerin içeriğinden veya uygulamalarından sorumlu değildir." },
      { h: "7. Koşulların geçerliliği", p: "Bu koşullar dönem dönem güncellenebilir. Web sitesini kullanmaya devam etmeniz, koşulların güncel sürümünü kabul ettiğiniz anlamına gelir." },
    ],
  },
  seo: {
    home: { title: "NORTIS — Gelişmiş ODF Çözümleri | Ağızda Çözünen Film İş Ortağınız", desc: "NORTIS, yenilikçi ağızda çözünen film (ODF) ürünlerini dünya genelindeki markalar, iş ortakları ve pazarlarla buluşturur. Distribütörlük, private label ve pazar geliştirme." },
    tech: { title: "ODF Teknolojisi — NORTIS", desc: "Ağızda çözünen film teknolojisine bilgilendirici bir bakış: format, yapı, kullanıcı deneyimi ve ticari olanaklar." },
    solutions: { title: "ODF Çözüm Portföyü — NORTIS", desc: "ODF çözüm kategorilerini keşfedin: günlük wellness, enerji, güzellik, uyku, fonksiyonel içerikler ve özel private label konseptleri." },
    partnership: { title: "Private Label ve Distribütörlük — NORTIS", desc: "ODF ürünleri için distribütörlük, private label veya pazar geliştirme modelleriyle NORTIS'in iş ortağı olun." },
    about: { title: "NORTIS Hakkında — Yarını Şekillendiren Formata Odaklanıyoruz", desc: "NORTIS, potansiyel taşıyan ODF inovasyonlarını bunları ticari ürünlere dönüştürebilecek markalar, iş ortakları ve pazarlarla buluşturur." },
    contact: { title: "NORTIS İletişim — Görüşme Başlatın", desc: "ODF distribütörlüğü, private label, ürün tedariki veya pazar geliştirme konularını görüşmek için NORTIS ekibiyle iletişime geçin." },
    privacy: { title: "Gizlilik Politikası — NORTIS", desc: "NORTIS'in bu web sitesi aracılığıyla iletilen bilgileri nasıl topladığı, kullandığı ve koruduğu hakkında bilgi." },
    terms: { title: "Kullanım Koşulları — NORTIS", desc: "NORTIS web sitesinin ve içeriğinin kullanımına ilişkin koşullar." },
  },
  a11y: {
    mainNav: "Ana gezinme menüsü",
    mobileNav: "Mobil gezinme menüsü",
    homeLink: "NORTIS ana sayfa",
    openMenu: "Menüyü aç",
    closeMenu: "Menüyü kapat",
    langSelector: "Dil seçin",
    filmDiagram: "Etkileşimli film katmanı diyagramı",
    linkedinLabel: "LinkedIn'de NORTIS",
    techImageAlt: "Soyut katmanlı film tabakaları",
    yes: "Evet",
    partial: "Kısmen",
    no: "Hayır",
    filters: "Çözüm filtreleri",
  },
  solutionsData: {
    "daily-wellness": {
      name: "Günlük Wellness",
      desc: "Modern sabah ve akşam rutinlerine doğal biçimde uyum sağlayacak şekilde tasarlanmış günlük film konseptleri.",
      possibilities: ["Rutin odaklı ürün serileri", "Abonelik modeline uygun formatlar", "Minimalist premium ambalaj"],
      positioning: "Günlük kullanımda zahmetsiz süreklilik arayan tüketiciler için konumlandırılmıştır.",
      availability: "İş ortaklarıyla geliştirme aşamasında",
      targetMarket: "Wellness ve yaşam tarzı perakendesi",
      docStatus: "Pazara göre hazırlanır",
    },
    "energy-performance": {
      name: "Enerji ve Performans",
      desc: "Antrenman, seyahat veya yoğun bir gün öncesinde dinamizme değer veren tüketiciler için hareket halinde kullanıma uygun konseptler.",
      possibilities: ["Aktivite öncesi konumlandırma", "Kompakt çoklu paket formatları", "Cesur ve modern marka dili"],
      positioning: "Hıza ve pratikliğe öncelik veren tüketim anları için tasarlanmıştır.",
      availability: "İş ortaklarıyla geliştirme aşamasında",
      targetMarket: "Aktif yaşam ve spor kanalları",
      docStatus: "Pazara göre hazırlanır",
    },
    "beauty-aging": {
      name: "Güzellik ve Sağlıklı Yaşlanma",
      desc: "Deneyimin ve estetiğin belirleyici olduğu içten güzellik kategorisi için zarif film konseptleri.",
      possibilities: ["Premium güzellik konumlandırması", "Hediyeye uygun ambalaj konseptleri", "Ritüel odaklı marka hikâyesi"],
      positioning: "Günlük güzellik ritüelini bir üst seviyeye taşıyan markalar için rafine bir format.",
      availability: "İş ortaklarıyla geliştirme aşamasında",
      targetMarket: "İçten güzellik ve premium perakende",
      docStatus: "Pazara göre hazırlanır",
    },
    "sleep-relaxation": {
      name: "Uyku ve Rahatlama",
      desc: "Günün sonunda sadeliği esas alan, sakin ve akşam kullanımına yönelik konseptler.",
      possibilities: ["Akşam ritüeli konumlandırması", "Dikkat çekmeyen başucu formatları", "Sakinleştirici duyusal tasarım"],
      positioning: "Dinlenmeden önceki o sakin an için tasarlanmıştır.",
      availability: "İş ortaklarıyla geliştirme aşamasında",
      targetMarket: "Akşam wellness ürünleri ve eczane perakendesi",
      docStatus: "Pazara göre hazırlanır",
    },
    "vitamins-functional": {
      name: "Vitaminler ve Fonksiyonel İçerikler",
      desc: "Bilinen fonksiyonel içerikler etrafında kurgulanan ve hassas, modern bir formatta sunulan film konseptleri.",
      possibilities: ["İçerik odaklı ürün aileleri", "Net ve şeffaf etiket tasarımı", "Format öncelikli farklılaşma"],
      positioning: "Yerleşik içerik kategorilerinde çağdaş bir alternatif.",
      availability: "İş ortaklarıyla geliştirme aşamasında",
      targetMarket: "Nutrasötik ve fonksiyonel ürün perakendesi",
      docStatus: "Pazara göre hazırlanır",
    },
    "custom-private-label": {
      name: "Özel ve Private Label Konseptleri",
      desc: "Boş bir tuval: Fikir aşamasından lansmana kadar, iş ortağının kendi markası altında geliştirilen özel ODF konseptleri.",
      possibilities: ["Tamamen özel konsept geliştirme", "Marka ve ambalaj koordinasyonu", "Lansman ve ölçeklendirme desteği"],
      positioning: "Tamamen kendine ait, fark yaratan bir ürün isteyen iş ortakları için.",
      availability: "Yeni projelere açık",
      targetMarket: "Marka sahipleri ve perakendeciler",
      docStatus: "Projeye göre tanımlanır",
    },
  },
};
